import Table from '../../../components/common/Table'
import Button from '../../../components/common/Button'
import { getImageUrl } from '../../../utils/helpers'
import { TeamMember } from '../Team'

interface TeamTableProps {
  members: TeamMember[]
  onEdit: (member: TeamMember) => void
  onDelete: (member: TeamMember) => void
  onToggleFeatured: (member: TeamMember) => void
  onToggleActive: (member: TeamMember) => void
}

function TeamTable({
  members,
  onEdit,
  onDelete,
  onToggleFeatured,
  onToggleActive,
}: TeamTableProps) {
  const columns = [
    {
      key: 'photo',
      label: 'Photo',
      render: (member: TeamMember) => (
        <div className="team-photo">
          {member.photo?.url ? (
            <img src={getImageUrl(member.photo.url)} alt={member.photo.alt || member.name} />
          ) : (
            <div className="team-photo-placeholder">
              {member.name.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
      ),
    },
    {
      key: 'name',
      label: 'Nom',
    },
    {
      key: 'role',
      label: 'Rôle',
    },
    {
      key: 'position',
      label: 'Position',
    },
    {
      key: 'featured',
      label: 'En vedette',
      render: (member: TeamMember) => (
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={member.featured}
            onChange={() => onToggleFeatured(member)}
          />
          <span className="toggle-slider"></span>
        </label>
      ),
    },
    {
      key: 'is_active',
      label: 'Actif',
      render: (member: TeamMember) => (
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={member.is_active}
            onChange={() => onToggleActive(member)}
          />
          <span className="toggle-slider"></span>
        </label>
      ),
    },
  ]

  return (
    <Table
      data={members}
      columns={columns}
      actions={(member) => (
        <div className="table-action-buttons">
          <Button variant="secondary" size="small" onClick={() => onEdit(member)}>
            Modifier
          </Button>
          <Button variant="outline" size="small" onClick={() => onDelete(member)}>
            Supprimer
          </Button>
        </div>
      )}
    />
  )
}

export default TeamTable
